"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseIndexItemAbstract = void 0;
const schemaName_1 = require("../schemaName");
class BaseIndexItemAbstract {
    constructor() {
        this.type = "";
        this.category = "";
        this.contents = { page: '' };
        this.description = "";
        this.ids = { globalName: '' };
        this.images = {};
        this.index = schemaName_1.SchemaName.page;
        this.keywords = "";
        this.links = { page: '' };
        this.name = "";
        this.objectID = "";
        this.occasions = [];
        this.popularity = "";
        this.view = { showCategory: true };
        this.weightInCategory = 0;
        this.distinctHash = "";
    }
}
exports.BaseIndexItemAbstract = BaseIndexItemAbstract;
